/**
 * Classe que testa os tipo Lookup
 * @author: Adalto Junior
 * DATE: 21/08/2014
 */


Monet.Format = Monet.Format || {};
Monet.Format.LOOKUP = (function () {

    function LOOKUP(value) {

        Monet.Format.ARRAY_BASED.apply(this, arguments);

        this.value = value;

        this.toGrid = function () {

            this.formatToString();

            return this;
        };

    }

    return LOOKUP;

}());
